import { useEffect, useState } from "react";

const css = `
.zoom-overlay {
  position: fixed; inset: 0; z-index: 3000;
  background: rgba(0,0,0,0);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  pointer-events: none;
  transition: background .3s ease;
}
.zoom-overlay.open {
  pointer-events: all;
  background: rgba(0,0,0,0.92);
  backdrop-filter: blur(10px);
}

.zoom-img-wrap {
  position: relative;
  max-width: 95vw;
  max-height: 90vh;
  transform: scale(0.8);
  opacity: 0;
  transition: transform .35s cubic-bezier(.22,1,.36,1), opacity .28s ease;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 32px 80px rgba(0,0,0,.8);
  border: 1px solid rgba(201,168,76,.2);
}
.zoom-overlay.open .zoom-img-wrap {
  transform: scale(1);
  opacity: 1;
}

.zoom-img-wrap img {
  display: block;
  max-width: 95vw;
  max-height: 85vh;
  width: auto;
  height: auto;
  object-fit: contain;
}

.zoom-close {
  position: absolute; top: 10px; left: 10px;
  width: 38px; height: 38px; border-radius: 50%;
  background: rgba(0,0,0,0.75);
  border: 2px solid rgba(255,255,255,0.35);
  color: #fff; font-size: 18px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; z-index: 10;
  transition: background .2s, transform .2s, border-color .2s;
  backdrop-filter: blur(4px);
}
.zoom-close:hover {
  background: rgba(201,168,76,0.85);
  border-color: #c9a84c; color: #080e14;
  transform: rotate(90deg);
}

/* cursor on the image that triggers zoom */
.zoomable {
  cursor: zoom-in;
}
`;

export default function ImageZoomModal({ src, alt = "" }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = (e) => e.key === "Escape" && setOpen(false);
    if (open) window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, [open]);


  return (
    <>
      <style>{css}</style>
      <img
        src={src}
        alt={alt}
        className="zoomable"
        onClick={() => setOpen(true)}
        draggable={false}
        loading="lazy"
      />

      {open && (
        <div className="zoom-overlay open">
          <div className="zoom-img-wrap">
            <button className="zoom-close" onClick={() => setOpen(false)}>✕</button>
            <img src={src} alt={alt} draggable={false} loading="lazy" />
          </div>
        </div>
      )}
    </>
  );
}
